import React from 'react';
import classNames from 'classnames';

export default function Container({
    children,
    columns,
    checkbox,
    spans,
    className = ""
}) {

    let classes = typeof className === "string" ? className.split(" ").reduce((acc, item) => {
        acc[item] = true
        return acc
    }, {}) : className;

    const ContainerClasses = classNames({
        "relative input-container px-2 box-border pt-5": true,
        "py-3": checkbox,
        "w-full": !columns || columns === 1,
        "w-full md:w-half": columns === 2,
        "w-full md:w-third": columns === 3,
        "w-full md:w-fourth": columns === 4,
        "col-span-1": spans === 1,
        "col-span-2": spans === 2,
        "col-span-3": spans === 3,
        "col-span-4": spans === 4,
        "col-span-5": spans === 5,
        "col-span-6": spans === 6,
        "col-span-7": spans === 7,
        "col-span-8": spans === 8,
        "col-span-9": spans === 9,
        "col-span-10": spans === 10,
        "col-span-11": spans === 11,
        "col-span-12": spans === 12,
        ...classes
    })

    return (
        <div className={ContainerClasses}>
            {children}
        </div>
    )
}
